import PremiumIcon from "assets/images/components/PremiumIcon";
import ContentBox from "components/ContentBox";
import Table from "components/Table";
import TitleSection from "components/TitleSection";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getExpenses } from "utils/api"



const TablesExpenses = () => {
  const { t } = useTranslation();
  const columns = [
    { label: t("tables.expenses.investment_fee"), accessor: "investment_fee", format: "CURRENCY_EUR"},
    { label: t("tables.expenses.management_fee_bonds") , accessor: "management_fee_bonds_pct", format: "PERCENTAGE"},
    { label: t("tables.expenses.management_fee_equity"), accessor: "management_fee_equity_pct", format: "PERCENTAGE" },
    { label: t("tables.expenses.capital_conversion_expenses"), accessor: "capital_conversion_expenses_pct", format: "PERCENTAGE"},
    { label: t("tables.expenses.capital_conversion_expenses_max_eur"), accessor: "capital_conversion_expenses_max_eur", format: "CURRENCY_EUR"},
  ];

  const [expenses, setExpenses] = useState();
  useEffect(() => {
    getExpenses().then(t => setExpenses(t))
  }, [])
  return (
      <ContentBox>
        <TitleSection title={t("tables.expenses.title")} Icon={PremiumIcon} />
        {expenses && <Table data={expenses} columns={columns} />}
      </ContentBox>

  );
};

export default TablesExpenses;
